import React, {useRef} from "react";
import Table, {tableNumberFilter, tableTextFilter} from "../Table/Table";
import {
    Button,
    ButtonGroup,
    Col,
    Dropdown,
    DropdownButton,
    OverlayTrigger,
    Row,
    Spinner,
    Tooltip
} from "react-bootstrap";
import {useLayoutEffect, useState} from "react";
import {TbCopy} from "react-icons/tb";
import {
    CONNECTED,
    DISCONNECTED,
    ERROR,
    PAIRED,
    PAIRING,
    TRAFFIC_ISSUE_SUSPECT,
    UNKNOWN,
    UNPAIRED,
    UNPAIRING,
    WAIT_GET_GUID_RES,
    WAIT_RESET_ADDR_RES,
    WAIT_SET_ADDR_RES,
    WAIT_SET_GREEN_LED_RES
} from "../../Pages/ControlUnits/Types";
import CustomIcon from "../CustomIcon/CustomIcon";
import greenEmptyCircle from "../../Images/green-empty-circle.png";
import greenCircle from "../../Images/green-circle.png";
import redCircle from "../../Images/red-circle.png";
import redEmptyCircle from "../../Images/red-empty-circle.png";
import greyCircle from "../../Images/grey-circle.png";
import greyEmptyCircle from "../../Images/grey-empty-circle.png";
import {CU_OFFLINE, CU_ONLINE} from "../../Constants/constants";

export default function VmaTable(props) {
    const headerStyle = {fontSize: 14, paddingBottom: 15};
    const wideHeaderStyle = {minWidth: 200, fontSize: 14, paddingBottom: 15};
    const widestHeaderStyle = {minWidth: 300, fontSize: 14, paddingBottom: 15};
    const colStyle = {minWidth: 100, fontSize: 14, paddingTop: 7, whiteSpace: 'nowrap'};
    const textColStyle = {maxWidth: 100, fontSize: 14, whiteSpace: 'nowrap'};
    const filtersRefs = useRef([]);
    const idFilterRef = useRef();
    const modelFilterRef = useRef();
    const hwVersionFilterRef = useRef();
    const swVersionFilterRef = useRef();
    const addressFilterRef = useRef();
    const numberOfDevicesFilterRef = useRef();
    const pairingStatusFilterRef = useRef();
    const [sortState, setSortState] = useState({dataField: 'order', order: 'asc'});

    const actionsFormatter = (cell, row) => {
        return (
            <>
                <div>
                    <DropdownButton
                        onToggle={(isOpen, event, metadata) => {
                            isOpen ? props.setIsVmaActionDropDownMenuOpen(true) : props.setIsVmaActionDropDownMenuOpen(false);
                        }}
                        as={ButtonGroup}
                        size="sm"
                        variant="outline-secondary"
                        title="Actions"
                    >
                        <Dropdown.Item onSelect={() => {
                            props.setShowEditVmaModal(true);
                            props.setSelectedRow(row);
                        }} eventKey="1">Edit</Dropdown.Item>
                        <Dropdown.Item onSelect={() => {
                            props.setShowDeleteVmaModal(true);
                            props.setSelectedRow(row);
                        }}
                                       eventKey="2">Delete</Dropdown.Item>
                    </DropdownButton>
                </div>
            </>
        )
    }

    const createStatusIcon = (imgSrc, connectionState, empty) => {
        return <OverlayTrigger
            placement='bottom'
            overlay={<Tooltip>{connectionState}</Tooltip>}>
                        <span tabindex="0">{
                            <CustomIcon
                                className={'ml-2 mb-1'}
                                width={empty ? 16 : 20}
                                height={empty ? 16 : 20}
                                src={imgSrc}
                                alt={"redCircle"}
                            />
                        }
                            </span>
        </OverlayTrigger>
    }

    const pairingStatusFormatter = (cell) => {
        let statusIcon;
        let statusIconVariable;
        let status;
        const connectionState = props.connectionState
        const connectionStatePaired = connectionState === CONNECTED ? 'onlinePaired' : 'offlinePaired';
        const connectionStateUnpaired = connectionState === CONNECTED ? 'onlineUnpaired' : 'offlineUnpaired';
        const connectionStateDisconnected = connectionState === CONNECTED ? 'onlineDisconnected' : 'offlineDisconnected';
        const connectionStateUnknown = 'unknown'
        switch (cell) {
            case PAIRED:
                statusIconVariable = connectionStatePaired;
                status = 'Paired';
                break;
            case UNPAIRED:
                statusIconVariable = connectionStateUnpaired;
                status = 'Unpaired';
                break;
            case PAIRING:
                statusIconVariable = connectionStateUnpaired;
                status = 'Unpaired';
                break;
            case UNPAIRING:
                statusIconVariable = connectionStatePaired;
                status = 'Paired';
                break;
            case ERROR:
                statusIconVariable = connectionStateUnknown;
                status = 'Unknown';
                break;
            case DISCONNECTED:
                statusIconVariable = connectionStateDisconnected;
                status = 'Disconnected';
                break;
            case WAIT_SET_ADDR_RES:
                statusIconVariable = connectionStateUnpaired;
                status = 'Unpaired';
                break;
            case WAIT_RESET_ADDR_RES:
                statusIconVariable = connectionStatePaired;
                status = 'Paired';
                break;
            case WAIT_GET_GUID_RES:
                statusIconVariable = connectionStateUnpaired;
                status = 'Unpaired';
                break;
            case WAIT_SET_GREEN_LED_RES:
                statusIconVariable = connectionStateUnpaired;
                status = 'Unpaired';
                break;
            case TRAFFIC_ISSUE_SUSPECT:
                statusIconVariable = connectionStatePaired;
                status = 'Paired';
                break;
            case UNKNOWN:
            default:
                statusIconVariable = connectionStateUnknown;
                status = 'Unknown';
        }
        switch (statusIconVariable) {
            case 'onlinePaired':
                statusIcon = createStatusIcon(greenCircle, CU_ONLINE, false);
                break;
            case 'offlinePaired':
                statusIcon = createStatusIcon(greenEmptyCircle, CU_OFFLINE, true);
                break;
            case 'onlineDisconnected':
                statusIcon = createStatusIcon(redCircle, CU_ONLINE, false);
                break;
            case 'offlineDisconnected':
                statusIcon = createStatusIcon(redEmptyCircle, CU_OFFLINE, true);
                break;
            case 'onlineUnpaired':
                statusIcon = createStatusIcon(greyCircle, CU_ONLINE, false);
                break;
            case 'offlineUnpaired':
                statusIcon = createStatusIcon(greyEmptyCircle, CU_OFFLINE, true);
                break;
            case 'unknown':
            default:
                statusIcon = null

        }
        return (
            <div style={{display: 'flex', justifyContent: 'start'}}>
                <div className='mr-2'>
                    {statusIcon}
                </div>
                <div className='mr-2'>
                    {status}
                </div>
            </div>
        )
    }

    const resetFilters = () => {
        filtersRefs.current.forEach(currFilter => {
            if (currFilter) currFilter('');
        })
        idFilterRef.current?.resetFilter();
        modelFilterRef.current?.resetFilter();
        hwVersionFilterRef.current?.resetFilter();
        swVersionFilterRef.current?.resetFilter();
        addressFilterRef.current?.resetFilter();
        numberOfDevicesFilterRef.current?.resetFilter();
        pairingStatusFilterRef.current?.resetFilter();
    }

    const Name = ({cell}) => {
        const [showToolTip, setShowToolTip] = useState(false);
        const ref = useRef(null);


        useLayoutEffect(() => {
            if (ref.current.clientWidth < ref.current.scrollWidth) {
                setShowToolTip(true);
            }
        }, [ref]);

        return (<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div className={'d-inline-block'}>
            </div>
            {showToolTip ? <OverlayTrigger placement="right" overlay={<Tooltip> {cell}</Tooltip>}>
                    <div ref={ref} style={{overflow: 'hidden', textOverflow: 'ellipsis'}} className={'d-inline-block'}>
                        {cell}
                    </div>
                </OverlayTrigger> :
                <div ref={ref} style={{overflow: 'hidden', textOverflow: 'ellipsis'}} className={'d-inline-block'}>
                    {cell}
                </div>}

            <div className={'d-inline-block'}>
                <Button className='p-0 m-0' variant={'link'} style={{color: 'black'}}>
                    <TbCopy onClick={() => props.copyTextToClipboard(cell)} size={25}/>
                </Button>
            </div>
        </div>)
    }

    const nameFormatter = (cell) => {
        return <Name cell={cell}/>
    }

    const onSort = (field, order) => {
        setSortState({dataField: field, order: order});
    }

    const columns = [
        {
            dataField: 'pairingState',
            text: <div>Connectivity <br/> Status</div>,
            headerStyle: {fontSize: 14},
            style: colStyle,
            formatter: pairingStatusFormatter,
            editable: false
        },
        {
            dataField: 'name',
            text: 'Name',
            headerStyle: widestHeaderStyle,
            style: textColStyle,
            formatter: nameFormatter,
            editable: false,
            filter: tableTextFilter(filtersRefs),
            sort: true,
            onSort: onSort
        },
        {dataField: 'modbusModel', text: 'Model', headerStyle: headerStyle, style: colStyle, editable: false},
        {
            dataField: 'hardwareVersion',
            text: 'H/W Revision',
            headerStyle: wideHeaderStyle,
            style: colStyle,
            editable: false
        },
        {
            dataField: 'softwareVersion',
            text: 'F/W Revision',
            headerStyle: headerStyle,
            style: colStyle,
            editable: false
        },
        {
            dataField: 'address',
            text: 'Address',
            headerStyle: headerStyle,
            style: colStyle,
            editable: false,
            filter: tableNumberFilter(filtersRefs),
            sort: true,
            onSort: onSort
        },
        {dataField: 'numberOfDevices', text: '# Devices', headerStyle: headerStyle, style: colStyle, editable: false},
        {
            dataField: 'actionMenu',
            text: '',
            headerStyle: headerStyle,
            formatter: actionsFormatter,
            style: textColStyle,
            editable: false
        },
    ]

    if (!props || props.isUpdateDetailsRequestInProgress && !props.isApplyingActive) {
        return (
            <Col md={{offset: 5, span: 1}}><Spinner animation="border" variant="primary"/></Col>
        )
    } else {
        return (
            <div style={{overflowX: 'hidden', overflowY: 'auto', height: props.tableHeight}}>
                <Table
                    isHeadersSticky={!props.tableHeight}
                    data={props.data}
                    columns={columns}
                    disablePagination
                    resetFilters={resetFilters}
                    defaultSort={sortState}
                />
            </div>
        )
    }
}
